import { NgModule, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular-ivy';
import { GlobalErrorHandler } from './shared/core/handlers/global-error.handler';
import { SharedModule } from './shared/shared.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { EventsModule } from './events/events.module';
import { RegistrationModule } from './registration/registration.module';
import { NotificationsService } from './shared/core/notifications/notifications.service';
import { StorageService } from './shared/core/storage/storage.service';
import { LoggingService } from './shared/core/logging/logging.service';
import { Angulartics2Module} from 'angulartics2';
import {Angulartics2GoogleTagManager} from 'angulartics2/gtm';
import {ConfirmationService} from 'primeng/api';
import {HttpClientModule} from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';



@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    BrowserAnimationsModule,
    EventsModule,
    RegistrationModule,
    HttpClientModule,
    Angulartics2Module.forRoot([Angulartics2GoogleTagManager]),
    NgbModule
  ],
  exports: [
    SharedModule
  ],
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    // Sentry route tracing -- Sentry.TraceService instruments Angular Router
    // so navigations show up as transactions; the no-op factory APP_INITIALIZER
    // just ensures the service is constructed at bootstrap time. When Sentry
    // is uninitialized (empty DSN), these are inert.
    { provide: Sentry.TraceService, deps: [Router] },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    StorageService,
    ConfirmationService,
    NotificationsService,
    LoggingService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
